import React, { Suspense, useEffect, useState } from "react";
import { isEmpty, map } from "lodash";
import translateService from "../../../common/translateService";
import common from "../../../common/common";
import { getQAndA } from "../../../services/questionAndAnswers/questionAndAnswersService";
import Button from "../../Button.jsx";
import "./ProductQuestionsAndAnswers.scss";

const ProductQuestionsAndAnswers = (props) => {
    const ProductQuestionAndAnswer = React.lazy(() =>
        import("./ProductQuestionAndAnswer.jsx")
    );
    const [questions, setQuestions] = useState({
        productSlug: "",
        questions: [],
        sortType: 2,
        viewingCount: 0,
        productTitle: null,
        writeAQuestionLink: "",
        guidelinesLink: "",
        allQuestionsLink: "",
        page: 0,
        pageSize: 10,
        totalRecords: 0,
        totalPages: 1,
    });

    async function init() {
        const q = await getQAndA(props.slug);
        setQuestions(q);
    }

    useEffect(() => {
        init();
    }, []);

    const qAndAs = map(questions.questions, (q, idx) => (
        <ProductQuestionAndAnswer
            question={q}
            key={idx}
            isAuthenticated={props.isAuthenticated}
            isMobile={props.isMobile}
        />
    ));

    return isEmpty(questions.questions) ? (
        <div className='prd-questions-text'>
            <p>{translateService.get(`questions.noQuestions`)}</p>
            <div className='prd-questions-button-container'>
                <Button
                    className='prd-questions-button'
                    text={translateService.get(`questions.makeAQuestion`)}
                    onClick={() => {
                        window.location = common.getSiteUrl(
                            questions.writeAQuestionLink
                        );
                    }}
                />
            </div>
        </div>
    ) : (
        <>
            <div className='prd-questions-text-info'>
                <p>{translateService.get(`questions.questionInfo`)}</p>
                <p
                    className='small'
                    dangerouslySetInnerHTML={{
                        __html: translateService.interpolate(
                            `questions.readTheGuideLines`,
                            {
                                guidelinesLink: common.getSiteUrl(
                                    questions.guidelinesLink
                                ),
                            }
                        ),
                    }}
                />
            </div>
            <div className='prd-questions-button-container'>
                <Button
                    className='prd-questions-button'
                    text={translateService.get(`questions.makeAQuestion`)}
                    onClick={() => {
                        window.location = common.getSiteUrl(
                            questions.writeAQuestionLink
                        );
                    }}
                />
            </div>
            <div className='prd-questions'>
                <Suspense fallback={""}>{qAndAs}</Suspense>
            </div>
            <div className='prd-questions-text allQuestions'>
                <a
                    className='prd-link'
                    href={common.getSiteUrl(questions.allQuestionsLink)}>
                    {translateService.get(`questions.allQuestions`)}
                </a>
            </div>
        </>
    );
};

export default ProductQuestionsAndAnswers;
